import React, { useState, useEffect } from "react";
// Импортируем картинки, чтобы сборщик их увидел
import wellcome1 from "../assets/wellcome1.jpg";
import wellcome2 from "../assets/wellcome2.jpg";
import { useTranslation } from "react-i18next";
import background from "../assets/background.webp"; // Если фоновая картинка тоже в assets
// Если фоновая картинка тоже в assets:
import { Link } from "react-router-dom";
const Welcome_Section = () => {
  const { t, i18n } = useTranslation();
  const list = t("wellcomelist", { returnObjects: true });
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isVisible = scrollPosition > 250;

  const show = isVisible ? "1" : "0";
  const translateX = isVisible ? "0" : "150px";
  const bgcolor = isVisible ? "#0058a3" : "#fff";
  const color = isVisible ? "#fff" : "rgb(53, 53, 53)";
  const anim = isVisible ? "widthh 2s ease-in-out forwards" : "none";

  return (
    <section
      id="wellcome"
      className="relative w-full h-auto py-[180px] px-5 flex flex-row justify-center items-start overflow-hidden transition-all duration-500 delay-300 bg-cover bg-center bg-no-repeat
                 max-[1024px]:flex-col-reverse max-[1024px]:items-center
                 max-[552px]:flex-col-reverse max-[552px]:py-[150px]"
      style={{
        opacity: show,
        backgroundColor: bgcolor,
        // Если картинка в папке public, используй "/background.png"
        // Если импортировал, используй `url(${background})`
        backgroundImage: isVisible ? `url(${background})` : "none",
      }}
    >
      {/* Контент с текстом */}
      <div
        className="max-w-3xl max-[1024px]:mx-0 max-[1024px]:my-[10px] max-sm:mt-12 flex flex-col justify-center items-start transition-all duration-500 delay-[600ms]
                      md:max-[1024px]:w-auto md:max-[1024px]:items-start
                      max-[552px]:px-[5px]"
      >
        <div className="w-full">
          <h1
            className="font-['Cormorant_Garamond'] uppercase text-[44px] font-normal leading-[1.22em] tracking-[0.15em] transition-all duration-500 delay-[800ms]
                       max-[768px]:text-[40px]
                       max-[552px]:text-[20px] max-sm:text-center max-[552px]:tracking-[10px]"
            style={{ color: color }}
          >
            {t("wellcometitle")}
          </h1>
        </div>
        <div className="w-full">
          <p className="text-[14px] tracking-[0.6em] max-sm:tracking-[0.3em] font-['Raleway'] font-medium mt-[13px] uppercase leading-[2.2em] max-[552px]:text-center text-yellow-400">
            {t("wellcometitle2")}
          </p>
        </div>
        <ul className="w-full flex flex-col gap-6 max-sm:px-3">
          {Array.isArray(list) &&
            list.map((text, index) => (
              <li
                key={index}
                className="text-white flex justify-start items-center relative before:w-2 before:h-2 before:absolute before:left-[-25px] before:top-1/2 before:-translate-y-1/2 before:bg-yellow-400 max-sm:text-[13px]"
              >
                {text}
              </li>
            ))}
        </ul>
        <Link
          to="/about"
          className="text-white mt-6 bg-yellow-600 px-4 py-2  transition-colors duration-300 hover:bg-yellow-500"
        >
         {t("wellcomrbtn")}
        </Link>
      </div>

      {/* Блок с изображениями */}
      <div
        className="w-[500px] h-[600px] bg-center bg-cover bg-no-repeat relative transition-all duration-500 delay-500 mx-20
                   max-[1024px]:w-[80%] max-[1024px]:h-[450px] max-[1024px]:mx-0
                   max-[552px]:w-full max-[552px]:h-[250px]"
        style={{
          opacity: show,
          transform: `translateX(${translateX})`,
          backgroundImage: `url(${wellcome1})`, // Используем переменную импорта
        }}
      >
        <div
          className="absolute w-[95%] h-[90%] bg-center bg-cover bg-no-repeat overflow-hidden top-[5%] left-1/2 border-l-[10px] border-yellow-400 transition-all duration-500
                     max-[1024px]:w-[60%] max-[1024px]:h-[50%] shadow-2xl max-[1024px]:left-0 max-[1024px]:-top-[30%]
                     max-sm:hidden"
          style={{
            opacity: show,
            transform: `translateX(${translateX})`,
            backgroundImage: `url(${wellcome2})`, // Используем переменную импорта
          }}
        >
          <div
            className="absolute w-full h-full bg-yellow-400 -left-full"
            style={{ animation: anim }}
          ></div>
        </div>
      </div>

      <style>{`
        @keyframes widthh {
            from { left: -100%; }
            to { left: 100%; }
        }
      `}</style>
    </section>
  );
};

export default Welcome_Section;
